import { Pipe, PipeTransform } from "@angular/core";

import { CartService } from "../../services/cart.service";
import { ItemCart } from "../../interfaces/itemCart.interface";

@Pipe({
    name: 'itemValue',
    pure: false
})
export class ItemValuePipe implements PipeTransform {

    transform(item: ItemCart): number {
        return ItemCart.calcTotalValue(item)
    }
}